if (!customElements.get('cart-free-shipping-progress')) {
  class CartFreeShippingProgress extends HTMLElement {
    connectedCallback() {
      this._threshold = parseInt(this.dataset.thresholdCents, 10) || 0;
      this._successMessage = this.dataset.successMessage || "You've unlocked free shipping!";

      this._onCartUpdated = (e) => this._update(e.detail.cart.total_price, e.detail.cart.item_count);
      document.addEventListener('cart:updated', this._onCartUpdated);

      this._watchProductsContainer();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onCartUpdated);
      if (this._observer) this._observer.disconnect();
    }

    _watchProductsContainer() {
      const productsEl = document.querySelector('[data-products]');
      if (!productsEl) return;

      this._syncFromProductsEl(productsEl);

      this._observer = new MutationObserver(() => this._syncFromProductsEl(productsEl));
      this._observer.observe(productsEl, { childList: true });
    }

    _syncFromProductsEl(productsEl) {
      const cartItemsEl = productsEl.querySelector('[data-cart-subtotal]');
      if (!cartItemsEl) return;
      const totalCents = parseInt(cartItemsEl.dataset.cartSubtotal, 10) || 0;
      const itemCount = parseInt(cartItemsEl.dataset.count, 10) || 0;
      this._update(totalCents, itemCount);
    }

    _update(totalCents, itemCount) {
      if (this._threshold <= 0) return;

      if (itemCount === 0) {
        this.hidden = true;
        return;
      }
      this.hidden = false;

      const remaining = Math.max(0, this._threshold - totalCents);
      const pct = Math.min(100, Math.floor(totalCents * 100 / this._threshold));

      const fill = this.querySelector('.cart-free-shipping__fill');
      const message = this.querySelector('.cart-free-shipping__message');
      const track = this.querySelector('.cart-free-shipping__track');

      if (fill) fill.style.width = pct + '%';
      if (track) {
        track.setAttribute('aria-valuenow', pct);
        track.setAttribute('aria-label', remaining === 0 ? this._successMessage : 'Add more for free shipping');
      }
      if (message) {
        if (remaining === 0) {
          message.textContent = this._successMessage;
        } else {
          const formatted = theme.Currency.formatMoney(remaining, theme.settings.moneyFormat);
          message.innerHTML = 'Add <span class="cart-free-shipping__amount">' + formatted + '</span> more for free shipping';
        }
      }
    }
  }

  customElements.define('cart-free-shipping-progress', CartFreeShippingProgress);
}
